import React, { useState, useEffect } from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import useSbt from "../hooks/sbtHook";
import useLocalStorageBackedList from "../hooks/localStorageListHook";
import useSbtPermissions from "../hooks/sbtPermissionsHook";

const useKnownGoodSbtAuthStore = (key = "knownAuthContracts") => {
  const list = useLocalStorageBackedList(key);

  return {
    sbtAuthContracts: list.values,
    addSbtAuthContract: list.addValue,
  };
};

const SbtPermissionSelector = ({ sbtAuthContractId, setSbtAuthContractId }) => {
  const sbtPermissions = useSbtPermissions();
  const { sbtAuthContracts, addSbtAuthContract } = useKnownGoodSbtAuthStore();

  const setContractId = (value) => {
    setSbtAuthContractId(value);
    console.log(value);
    sbtPermissions.getContractMetadata(value).then((result) => {
      console.log(result)
      if (result?.spec?.match(/^sbt-permissions-\d/g)) {
        addSbtAuthContract(value);
      }
    });
  };

  return (
    <Autocomplete
      id="sbt-permission-selector"
      freeSolo
      value={sbtAuthContractId || ""}
      onChange={(e, newValue) => {
        setContractId(newValue || "");
      }}
      options={sbtAuthContracts}
      renderInput={(params) => (
        <TextField
          {...params}
          label="SBT Auth Contract ID"
          onChange={(e) => setContractId(e.target.value || "")}
        />
      )}
    />
  );
};

export default SbtPermissionSelector;
